import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

function News() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get('/api/news');
        setNews(response.data);
      } catch (error) {
        console.error('Error fetching news:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  if (loading) {
    return (
      <div className="container py-5">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Page Header - Tema General Style */}
      <div
        className="container-fluid"
        style={{
          background: 'linear-gradient(rgba(var(--tgh-blue-rgb), 0.9), rgba(var(--tgh-blue-rgb), 0.9)), url(/img/news.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 0 3rem',
        }}
      >
        <div className="container">
          <div className="text-center">
            <h1 className="text-white mb-0" style={{ fontSize: '2.5rem', fontWeight: '600', fontFamily: "'Lora', 'Georgia', serif" }}>
              Media Center
            </h1>
            <p className="text-white mt-3 mb-0" style={{ fontSize: '1.1rem', opacity: 0.9 }}>
              Latest news and updates from Tema General Hospital
            </p>
            <nav aria-label="breadcrumb" className="mt-3 d-flex justify-content-center">
              <ol className="breadcrumb mb-0" style={{ backgroundColor: 'transparent', padding: 0 }}>
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>
                    Home
                  </Link>
                </li>
                <li className="breadcrumb-item active text-white" aria-current="page" style={{ color: '#fff' }}>
                  Media Center
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {/* News Section - Tema General Style */}
      <section className="tgh-news-listing py-5" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <h2 className="tgh-section-title mb-2" style={{ fontSize: '2rem', fontWeight: '600', color: '#1a1a1a' }}>Latest News</h2>
              <p className="text-muted" style={{ fontSize: '1rem' }}>Stay updated with the latest news and announcements from Tema General Hospital</p>
            </div>
          </div>
          <div className="row g-4 tgh-card-grid">
            {news.length === 0 ? (
              <div className="col-12 text-center py-5">
                <p className="text-muted" style={{ fontSize: '1rem' }}>No news articles available at this time.</p>
              </div>
            ) : (
              news.map((post) => (
                <div key={post.id} className="col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="card h-100 tgh-news-card" style={{ border: '1px solid #e0e0e0', borderRadius: '8px', overflow: 'hidden', transition: 'all 0.3s ease' }}>
                    <div className="tgh-card-media">
                      <img
                        src={post.image ? `/uploads/${post.image}` : '/img/Gallery/opd1.jpg'}
                        className="card-img-top"
                        alt={post.title}
                        onError={(e) => {
                          e.target.src = '/img/Gallery/opd1.jpg';
                        }}
                      />
                    </div>
                    <div className="card-body d-flex flex-column p-4">
                      <h5 className="card-title mb-3" style={{ fontSize: '1.15rem', fontWeight: '600', color: '#1a1a1a', lineHeight: '1.4' }}>
                        <Link to={`/news/${post.id}`} className="text-decoration-none" style={{ color: '#1a1a1a' }}>
                          {post.title}
                        </Link>
                      </h5>
                      <p className="card-text text-muted mb-2" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                        {post.content && post.content.length > 120 
                          ? `${post.content.replace(/<[^>]*>/g, '').substring(0, 120)}...` 
                          : post.content ? post.content.replace(/<[^>]*>/g, '') : ''}
                      </p>
                      <div className="mb-3" style={{ fontSize: '0.85rem', color: '#6c757d' }}>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <i className="bi bi-calendar3"></i>
                          <span>{formatDate(post.date)}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <i className="bi bi-person"></i>
                          <span>{post.username || post.full_name || 'Admin'}</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <i className="bi bi-heart"></i>
                          <span>{post.like_count || 0} {post.like_count === 1 ? 'Like' : 'Likes'}</span>
                        </div>
                      </div>
                      <Link
                        to={`/news/${post.id}`}
                        state={{ post }}
                        className="btn btn-primary mt-auto"
                        style={{ 
                          borderRadius: '4px', 
                          padding: '0.6rem 1.5rem',
                          fontWeight: '500',
                          backgroundColor: 'var(--tgh-blue-light)',
                          borderColor: 'var(--tgh-blue-light)',
                          transition: 'all 0.2s'
                        }}
                      >
                        Read More <i className="bi bi-arrow-right ms-2"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default News;
